<template>
  <div class="tab-general-ui-custom">
    <el-form
      v-if="isFba"
      :disabled="!isEdit"
      class="section"
      style="flex-direction: row;"
    >
      <span style="display: flex;align-items: center;width: 64px">
        {{ $t('FbaJob.ValueAddedServices') }}
      </span>
      <el-checkbox-group v-model="selectedLocalAddedService" no="selectedLocalAddedService" @change="addedServiceChangeHandler">
        <el-checkbox
          v-for="item in localAddedService"
          :key="item.code"
          :label="item.code"
          style="margin-left: 8px;margin-right: 8px"
          no="localAddedService"
          @change="val => singleAddedServiceChangeHandler(val, item)"
        >
          {{ item.chineseName }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-if="isAeBooking" v-model="job.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <el-form
      v-if="!isFba"
      :disabled="!isEdit"
      class="section"
      style="flex-direction: row;line-height: 28px;"
    >
      <el-checkbox v-model="job.virtualHBL" no="49">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
      <el-checkbox v-model="job.itmService" no="50" style="margin-left: -20px">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <span
        v-if="viewSource === 'AeBooking'"
        id="Insure"
        v-permission="['button_insurance_toInsure']"
        type="primary"
        :class="viewStatus?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
        style="min-width:46px!important;margin-left:15px"
        no="129"
        @click="()=>{if (viewStatus){pm.toInsure()}}"
      >{{ $t('SeaExport.Insure') }}
      </span>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <el-form ref="basicForm" :disabled="viewStatus" style="display: flex;" label-position="right" label-width="120px">
      <tab-general-UICustom-layout :element-blocks="elementBlocks" :element-dict="elementDict">
        <el-form-item v-if="elementDict.jobNo && elementDict.jobNo.viewable" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input v-model="job.jobNo" no="1" :disabled="true || !elementDict.jobNo.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.operateType && elementDict.operateType.viewable" slot="operateType">
          <line-label slot="label" :class="elementDict.operateType.isRequire ? 'blue' : ''" :label="elementDict.operateType.label" />
          <cargo-advance-select
            no="2"
            :clearable="false"
            filterable
            :select-type="selectTypeNames.local_cache_AirExportConstants$BUSINESS_MODELS"
            :default-value="job.operateType"
            :disabled="!operateTypeEnable || !elementDict.operateType.writable"
            :class="importDifferenceField.operateType ? 'red-border' : ''"
            @parentCallBack="p => {pm.operateTypeChangeHandler(p)}"
          />
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              clearable
              :data-filter-function="p => {
                if (!p.statusEnabled) {
                  return false
                }
                return isFba ? p.fbaAir : p.airExportEnabled
              }"
              :default-value="this.job.saleProductCode || ''"
              @parentCallBack="p => {this.job.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              clearable
              :default-value="this.job.fullOrInside || ''"
              @parentCallBack="p => {this.job.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.customerId && elementDict.customerId.viewable" slot="customerId">
          <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageB"
              no="3"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <img
                :class="job.customerId&&viewStatus?'':'not-click'"
                :src="sopPic"
                width="18"
                height="28"
                class="sop-img"
                style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
                @click="pm.sopChangeCustomerIdHandler()"
              >
            </el-tooltip>
            <el-tooltip
              v-show="showWarningImageB"
              :content="warningImageBTip"
              placement="right-end"
            >
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <cargo-sales-company-select
              v-if="!isFba"
              no="4"
              class="shipper-selector"
              popper-class="shipper-selector-popper"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{customer:true,active:true,companyLob:'airExport'}"
              :default-value="job.customerId||''"
              :check-credit="true"
              :disabled="!customerEnabled || !elementDict.customerId.writable"
              placeholder=" "
              :style="{width: (showWarningImageB||sopImageB ) ?'180px':'200px'}"
              :job="job"
              :class="importDifferenceField.customerId ? 'red-border' : ''"
              @parentCallBack="p=>{customerIdChange2ContractHandler(p)}"
            />
            <cargo-company-select
              v-if="isFba"
              no="customerId"
              class="shipper-selector"
              popper-class="shipper-selector-popper"
              :method-params="{customer:true,companyLob:'airExport',active:true, fba:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.customerId||''"
              :disabled="!customerEnabled || !elementDict.customerId.writable"
              :data-filter-function="fbaCustomerIdFilter"
              placeholder=" "
              :style="{width: (showWarningImageB||sopImageB ) ?'180px':'200px'}"
              @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.customerLevel && elementDict.customerLevel.viewable" slot="customerLevel">
          <line-label slot="label" :class="elementDict.customerLevel.isRequire ? 'blue' : ''" :label="elementDict.customerLevel.label" />
          <el-tooltip :content="customerTip" placement="bottom">
            <span
              v-show="customerLevel.customerName"
              style="color:#FD9A14"
            >LV{{ customerLevel.level }}</span>
            <span
              v-show="customerLevel.customerName"
              style="color:#D3A73B"
            >&nbsp;{{ customerLevel.customerName }}</span>
            <span v-show="contractStatusLabel" style="color:red">&nbsp;({{ contractStatusLabel }})</span>
            <span v-show="advancePaymentLabel" style="color:firebrick">&nbsp;({{ advancePaymentLabel }})</span>
            <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
              <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
            </span>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace && elementDict.dispatchingPlace.viewable" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <el-input
            v-model="job.dispatchingPlace"
            no="dispatchingPlace"
            :disabled="!elementDict.dispatchingPlace.writable"
            :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.loadingPortCode && elementDict.loadingPortCode.viewable" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input no="5" :value="loading3Code" style="width:60px;margin-right: 5px;" :disabled="true" />
            <cargo-advance-select
              ref="loadingPortCode"
              no="6"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="job.loadingPortCode"
              style="flex:1"
              tag-name="englishName"
              :disabled="!!job.lclMasterUuid || !elementDict.loadingPortCode.writable"
              placeholder=" "
              :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.loadingPortCodeChange(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortCode && elementDict.destinationPortCode.viewable" slot="destinationPortCode">
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input no="7" :value="destination3Code" style="width:60px;margin-right: 5px;" :disabled="true" />
            <cargo-advance-select
              no="8"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="job.destinationPortCode"
              :disabled="!!job.lclMasterUuid || !elementDict.destinationPortCode.writable"
              placeholder=" "
              style="flex:1"
              :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.destinationPortCodeChange(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPlace && elementDict.destinationPlace.viewable" slot="destinationPlace">
          <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.destinationPlace" :disabled="!elementDict.destinationPlace.writable" :class="importDifferenceField.destinationPlace ? 'red-border' : ''" no="9" @input="val=>pm.destinationPlaceChange(val)" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.vesselLine && elementDict.vesselLine.viewable" slot="vesselLine">
          <line-label slot="label" :class="elementDict.vesselLine.isRequire ? 'blue' : ''" :label="elementDict.vesselLine.label" />
          <el-input v-model="vesselLine" no="10" :disabled="true || !elementDict.vesselLine.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.transfering && elementDict.transfering.viewable" slot="transfering">
          <div style="display: flex;justify-content: space-between">
            <el-checkbox v-model="job.transfering" :disabled="!elementDict.transfering.writable" no="11">{{ elementDict.transfering.label }}</el-checkbox>
            <el-button
              no="12"
              :disabled="viewStatus || (!viewStatus && !job.transfering) || !elementDict.transfering.writable"
              :title="$t('SeaExport.EnterTransitInfo')"
              type="primary"
              style="display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;margin-left: 2px;"
              @click="setTransferingHandler"
            >
              {{ $t('SeaExport.EnterTransitInfo') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSource && elementDict.cargoSource.viewable" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="13"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.local_cache_CargoSource"
              :default-value="job.cargoSource"
              :disabled="!elementDict.cargoSource.writable"
              :fields="['chineseName']"
              :class="importDifferenceField.cargoSource ? 'red-border' : ''"
              @parentCallBack="p=>{pm.cargoSourceChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <!--产品服务-->
        <el-form-item v-if="elementDict.serviceProduct && elementDict.serviceProduct.viewable" slot="serviceProduct">
          <line-label slot="label" :class="elementDict.serviceProduct.isRequire ? 'blue' : ''" :label="elementDict.serviceProduct.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="145"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.basic_data_AirServiceProduct"
              callback-method-type="value"
              :default-value="job.serviceProduct"
              :callback-params="{key:'serviceProduct'}"
              :disabled="!elementDict.serviceProduct.writable"
              @parentCallBack="setJobSelectValue"
            />
          </div>
        </el-form-item>
        <!--航线产品-->
        <el-form-item v-if="elementDict.airlineProductUuid && elementDict.airlineProductUuid.viewable" slot="airlineProductUuid">
          <line-label slot="label" :class="elementDict.airlineProductUuid.isRequire ? 'blue' : ''" :label="elementDict.airlineProductUuid.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="airlineProductUuid"
              filterable
              :static-options="airlineProductDownList"
              :method-params="{active:true}"
              tag-value="uuid"
              tag-name="name"
              :filter-tag-names="['name']"
              :static-component="new AutoComplete()"
              callback-method-type="value"
              :default-value="job.airlineProductUuid"
              :callback-params="{key:'airlineProductUuid'}"
              :disabled="!elementDict.airlineProductUuid.writable"
              @parentCallBack="setJobSelectValue"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType && elementDict.customJobType.viewable" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            no="14"
            filterable
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :method-params="{type:job.lob}"
            :default-value="job.customJobType"
            :static-options="customJobTypeList"
            placeholder=" "
            :class="importDifferenceField.customJobType ? 'red-border' : ''"
            :disabled="!elementDict.customJobType.writable"
            @parentCallBack="p=>{job.customJobType=p.value;oncustomJobTypeChange(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.secondaryCustomJobType && elementDict.secondaryCustomJobType.viewable && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :cache="false"
            :default-value="job.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            :disabled="!elementDict.secondaryCustomJobType.writable"
            @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.appraisalCategory && elementDict.appraisalCategory.viewable" slot="appraisalCategory">
          <line-label slot="label" :class="elementDict.appraisalCategory.isRequire ? 'blue' : ''" :label="elementDict.appraisalCategory.label" />
          <cargo-advance-select
            no="146"
            filterable
            :select-type="selectTypeNames.basic_data_AppraisalCategory"
            :default-value="job.appraisalCategory"
            placeholder=" "
            :disabled="!elementDict.appraisalCategory.writable"
            @parentCallBack="p=>{job.appraisalCategory=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.localAgent && elementDict.localAgent.viewable" slot="localAgent">
          <line-label slot="label" :class="elementDict.localAgent.isRequire ? 'blue' : ''" :label="elementDict.localAgent.label" />
          <cargo-advance-select
            no="15"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{localAgent:true,active: true}"
            :default-value="job.localAgent||''"
            placeholder=" "
            :class="importDifferenceField.localAgent ? 'red-border' : ''"
            :disabled="!elementDict.localAgent.writable"
            @parentCallBack="p=>{pm.localAgentChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationAgent && elementDict.destinationAgent.viewable" slot="destinationAgent">
          <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip v-show="showWarningImageC" :content="warningImageCTip" placement="right-end">
              <i
                class="el-icon-warning"
                style="color:red"
              />
            </el-tooltip>
            <cargo-advance-select
              no="16"
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true, active: true}"
              :default-value="job.destinationAgent||''"
              tag-name="englishName"
              placeholder=" "
              :class="importDifferenceField.destinationAgent ? 'red-border' : ''"
              :disabled="!elementDict.destinationAgent.writable"
              @parentCallBack="p=>{pm.destinationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.designationAgent && elementDict.designationAgent.viewable && job.cargoSource === 'NC'" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageA"
              no="17"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :class="job.designationAgent&&viewStatus?'':'not-click'"
                  :src="sopPic"
                  width="18"
                  height="28"
                  class="sop-img"
                  style="padding: 5px 0;cursor: pointer"
                  no="designationAgent"
                  @click="pm.sopChangeBookingAgentHandler()"
                >
              </div>
            </el-tooltip>
            <el-tooltip
              v-show="showWarningImageA"
              :content="warningImageATip"
              placement="right-end"
            >
              <i class="el-icon-warning" style="color:red; cursor: pointer" />
            </el-tooltip>
            <cargo-advance-select
              no="18"
              class="designation-agent-selector"
              popper-class="designation-agent-selector-popper"
              :select-type="selectTypeNames.basic_data_Company"
              :disabled="!designationAgentEnabled || !elementDict.designationAgent.writable "
              :method-params="{designationAgent:true,active:true}"
              :check-credit="true"
              :default-value="job.designationAgent||''"
              filterable
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              tag-name="englishName"
              placeholder=" "
              :class="importDifferenceField.designationAgent ? 'red-border' : ''"
              @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent && elementDict.exChangeAgent.viewable && job.cargoSource === 'NC'" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-company-select
            no="exChangeAgent"
            :disabled="!job.dischargingPortDoor || !elementDict.exChangeAgent.writable"
            :method-params="{bookingAgent:true,active:true}"
            :default-value="job.exChangeAgent||''"
            :class="importDifferenceField.exChangeAgent ? 'red-border' : ''"
            @change="onExChangeAgentChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent && elementDict.bookingAgent.viewable && bookingAgentVisible" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-advance-select
            no="19"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true, active: true}"
            :default-value="job.bookingAgent||''"
            :disabled="!bookingAgentEnabled || !elementDict.bookingAgent.writable"
            placeholder=" "
            :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
            @parentCallBack="p => {pm.bookingAgentChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.fileCutoff && elementDict.fileCutoff.viewable" slot="fileCutoff">
          <line-label slot="label" :class="elementDict.fileCutoff.isRequire ? 'blue' : ''" :label="elementDict.fileCutoff.label" />
          <el-date-picker
            ref="fileCutoff"
            v-model="job.fileCutoff"
            no="20"
            :disabled="!!job.lclMasterUuid || !elementDict.fileCutoff.writable"
            clearable
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            style="width: 100%"
            :class="importDifferenceField.fileCutoff ? 'red-border' : ''"
            @blur="()=> { handleBlur('fileCutoff', null, true, false, job) }"
          />
        </el-form-item>
        <template v-if="elementDict.mbl && elementDict.mbl.viewable" slot="mbl">
          <el-form-item>
            <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
            <el-checkbox v-model="job.express" :disabled="!elementDict.mbl.writable" style="margin-right: 2px" no="122" @change="expressChangeHandler">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
            <el-input v-if="job.express" v-model="job.mbl" :disabled="!elementDict.mbl.writable" no="21" style="width: 130px;" @change="mblChange" />
            <mawb-no-input v-show="!job.express" ref="mawbNoInput" v-model="job.mbl" no="22" :editable="isEditablemawbNoInput || !elementDict.mbl.writable" @change="mblChangeEvent" @changeCallback="mblCheckHandler(true)" />
          </el-form-item>
          <el-form-item>
            <el-button no="23" :disabled="!propertiesEnabled.selectBtnEnabled" type="primary" @click="openMAWBHandler">{{ $t('SeaExport.Select') }}</el-button>
            <el-button no="24" :disabled="!propertiesEnabled.newConsoleBtnEnabled" type="primary" @click="newConsoleHandler">{{ $t('SeaExport.New') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button no="25" :disabled="!propertiesEnabled.attachBtnEnabled" type="primary" @click="attachMAWBHandler">{{ $t('SeaExport.Add3') }}</el-button>
            <el-button no="26" :disabled="!propertiesEnabled.deattachBtnEnabled" type="primary" @click="deattachMAWBHandler">{{ $t('SeaExport.Separate') }}</el-button>
          </el-form-item>
        </template>
        <template v-if="elementDict.jobSoNo && elementDict.jobSoNo.viewable" slot="jobSoNo">
          <el-form-item>
            <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
            <so-no-input v-model="job.jobSoNo" no="27" :disabled="viewStatus || !elementDict.jobSoNo.writable" />
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="job.predictionOperation" :disabled="!elementDict.jobSoNo.writable" no="28">{{ $t('SeaExport.PreAlertOperation') }}</el-checkbox>
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.portOfDestinationServices && elementDict.portOfDestinationServices.viewable && !isFba && isAeBooking" slot="portOfDestinationServices">
          <line-label slot="label" :class="elementDict.portOfDestinationServices.isRequire ? 'blue' : ''" :label="elementDict.portOfDestinationServices.label" />
          <el-checkbox
            v-model="job.dischargingPortDoor"
            no="dischargingPortDoor"
            class="checkbox-content"
            :title="$t('SeaExport.DispatchVehiclesAtDestination')"
            @change="dischargingPortDoorClick"
          >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
          </el-checkbox>
          <el-checkbox
            v-model="job.usCustomsClearance"
            no="usCustomsClearance"
            class="checkbox-content"
            :title="$t('queryJob.UsCustomsClearance')"
          >{{ $t('queryJob.UsCustomsClearance') }}
          </el-checkbox>
          <el-checkbox
            v-model="job.destPortCustomsClearance"
            no="destPortCustomsClearance"
            class="checkbox-content"
            :title="$t('SeaExport.PortOfDestinationCustomsClearance')"
          >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
          </el-checkbox>
        </el-form-item>
        <el-form-item v-if="elementDict.customerContact && elementDict.customerContact.viewable" slot="customerContact" label-width="120px">
          <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
          <div style="display: flex;justify-content: space-between">
            <el-select v-model="job.customerContact" :disabled="!elementDict.customerContact.writable" :class="importDifferenceField.customerContact ? 'red-border' : ''" no="29" filterable :allow-create="true" placeholder=" ">
              <el-option
                v-for="(item,index) in contactList"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
            <el-link v-show="!isShowContactPersonDetail" no="30" style="width: 80px" @click="showContactsInfoDialog=true">{{ $t('SeaExport.Detail') }}</el-link>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.contactTelephone && elementDict.contactTelephone.viewable" slot="contactTelephone" label-width="120px">
          <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
          <el-input v-model="job.contactTelephone" :disabled="!elementDict.contactTelephone.writable" :class="importDifferenceField.contactTelephone ? 'red-border' : ''" no="31" />
        </el-form-item>
        <el-form-item v-if="elementDict.contactFax && elementDict.contactFax.viewable" slot="contactFax" label-width="120px">
          <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
          <el-input v-model="job.contactFax" :disabled="!elementDict.contactFax.writable" :class="importDifferenceField.contactFax ? 'red-border' : ''" no="32" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingTerm && elementDict.loadingTerm.viewable" slot="loadingTerm" label-width="120px">
          <line-label slot="label" :class="elementDict.loadingTerm.isRequire ? 'blue' : ''" :label="elementDict.loadingTerm.label" />
          <cargo-advance-select
            ref="loadingTerm"
            no="33"
            filterable
            :select-type="selectTypeNames.local_cache_AirExportConstants$SUFFY_TYPES"
            callback-method-type="value"
            :default-value="job.loadingTerm"
            :fields="['chineseName']"
            :tag-name="isZh ? 'chineseName' : 'englishName'"
            :callback-params="{key:'loadingTerm'}"
            placeholder=" "
            :class="importDifferenceField.loadingTerm ? 'red-border' : ''"
            :disabled="!elementDict.loadingTerm.writable"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="isFba && isAeBooking && job.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
          <el-checkbox-group v-model="selectedPodAddedService" no="123" @change="addedServiceChangeHandler">
            <el-checkbox
              v-for="item in podAddedService"
              :key="item.code"
              :label="item.code"
              style="display:block"
              no="124"
              @change="val => singleAddedServiceChangeHandler(val, item)"
            >
              {{ item.chineseName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="elementDict.quotationNo && elementDict.quotationNo.viewable" slot="quotationNo" label-width="120px">
          <line-label slot="label" :class="elementDict.quotationNo.isRequire ? 'blue' : ''" :label="elementDict.quotationNo.label" />
          <el-input no="34" :value="job.quotationNo" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingTerm && elementDict.bookingTerm.viewable" slot="bookingTerm" label-width="120px">
          <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
          <cargo-advance-select
            no="35"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.local_cache_BookingTerm"
            :default-value="job.bookingTerm"
            :disabled="!propertiesEnabled.bookingTermEnabled || !elementDict.bookingTerm.writable"
            :fields="['chineseName']"
            :class="importDifferenceField.bookingTerm ? 'red-border' : ''"
            @parentCallBack="p => {pm.bookingTermChangeHandler(p)}"
          />
        </el-form-item>
        <!-- 报关方式-->
        <el-form-item v-if="elementDict.customClaim && elementDict.customClaim.viewable" slot="customClaim" label-width="120px">
          <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
          <cargo-advance-select
            v-if="!isFba"
            no="36"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:2}"
            tag-value="serialNum"
            filterable
            :default-value="job.customClaim"
            :class="importDifferenceField.customClaim ? 'red-border' : ''"
            :disabled="!elementDict.customClaim.writable"
            @parentCallBack="p=>{job.customClaim=p.value}"
          />
          <cargo-advance-select
            v-if="isFba"
            no="customsMethodPol"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:0}"
            filterable
            :clearable="false"
            :default-value="fbaJob.customsMethodPol"
            @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="isFba" :label="$t('AirExport.CustomsClearanceMethod')" label-width="120px">
          <cargo-advance-select
            no="customsMethodPod"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:1}"
            filterable
            :clearable="false"
            :default-value="fbaJob.customsMethodPod"
            @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsClaim2 && elementDict.customsClaim2.viewable && Number(job.customClaim) === 1" slot="customsClaim2" label-width="120px">
          <line-label slot="label" :class="elementDict.customsClaim2.isRequire ? 'blue' : ''" :label="elementDict.customsClaim2.label" />
          <cargo-advance-select
            no="37"
            filterable
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            :default-value="job.customsClaim2 || 0"
            :disabled="!elementDict.customsClaim2.writable"
            @parentCallBack="p=>{job.customsClaim2=p.value;job.customsDeclarationType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm && elementDict.tradeTerm.viewable" slot="tradeTerm" label-width="120px">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="38"
            filterable
            :clearable="false"
            :disabled="!elementDict.tradeTerm.writable"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            callback-method-type="value"
            :default-value="job.tradeTerm"
            :class="importDifferenceField.tradeTerm ? 'red-border' : ''"
            :callback-params="{key:'tradeTerm'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.declareCustomsState && elementDict.declareCustomsState.viewable" slot="declareCustomsState" label-width="120px">
          <line-label slot="label" :class="elementDict.declareCustomsState.isRequire ? 'blue' : ''" :label="elementDict.declareCustomsState.label" />
          <cargo-advance-select
            no="39"
            filterable
            :disabled="false || !elementDict.declareCustomsState.writable"
            :select-type="selectTypeNames.local_cache_SystemConstants$DECLARE_CUSTOMS_STATE"
            :default-value="job.declareCustomsState || ''"
            :tag-name="isZh?'chineseName':'englishName'"
            :fields="['chineseName']"
            :class="importDifferenceField.declareCustomsState ? 'red-border' : ''"
            @parentCallBack="p=>{job.declareCustomsState=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.incoTerm && elementDict.incoTerm.viewable" slot="incoTerm" label-width="120px">
          <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
          <cargo-advance-select
            no="40"
            filterable
            :clearable="false"
            :disabled="!elementDict.incoTerm.writable"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            callback-method-type="value"
            :default-value="job.incoTerm"
            :callback-params="{key:'incoTerm'}"
            placeholder=" "
            :class="importDifferenceField.incoTerm ? 'red-border' : ''"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carrierId && elementDict.carrierId.viewable" slot="carrierId" label-width="120px">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-advance-select
            no="41"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{airCmp:true, companyLob:'airExport',active:true}"
            :default-value="job.carrierId||''"
            :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
            :fields="['shortName', 'chineseName']"
            :disabled="!airlineCompanyEnabled || !elementDict.carrierId.writable"
            placeholder=" "
            :class="importDifferenceField.carrierId ? 'red-border' : ''"
            @parentCallBack="p => {pm.airlineCompanyChangeHandler(p.value||0);pm.airlineCompanyChange(p.value||0);airlineCompanyCheckHandler(p.value||0)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carrierWebsite && elementDict.carrierWebsite.viewable" slot="carrierWebsite">
          <line-label slot="label" :class="elementDict.carrierWebsite.isRequire ? 'blue' : ''" :label="elementDict.carrierWebsite.label" />
          <cargo-textarea v-model="job.carrierWebsite" no="carrierWebsite" type="textarea" :row="3" :disabled="!elementDict.carrierWebsite.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight && elementDict.voyageFlight.viewable" slot="voyageFlight" label-width="120px">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <el-input v-model="job.voyageFlight" no="42" :class="importDifferenceField.voyageFlight ? 'red-border' : ''" :disabled="!flightEnabled || !elementDict.voyageFlight.writable" @change="voyageFlightCheckHandler" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.viewable" slot="customsDate" label-width="120px">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker
            v-model="job.customsDate"
            :disabled="!elementDict.customsDate.writable"
            no="43"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 100%"
            :class="importDifferenceField.customsDate ? 'red-border' : ''"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.etd && elementDict.etd.viewable" slot="etd" label-width="120px">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              ref="etd"
              :value="job.etd"
              no="44"
              :disabled="!!job.lclMasterUuid || !elementDict.etd.writable || provisionEtdLocked"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              clearable
              style="flex: 1; width:170px; margin-right: 5px"
              :class="importDifferenceField.etd ? 'red-border' : ''"
              @input="etdChange"
              @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
            />
            <span>{{ job.sailingDay|filterWeek }}</span>
          </div>
          <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
        </el-form-item>
        <el-form-item v-if="elementDict.eta && elementDict.eta.viewable" slot="eta" label-width="120px">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              ref="eta"
              v-model="job.eta"
              no="45"
              :disabled="!!job.lclMasterUuid || !elementDict.eta.writable"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              style="flex: 1; width:170px; margin-right: 5px"
              :class="importDifferenceField.eta ? 'red-border' : ''"
              clearable
              @input="etaChange"
              @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
            />
            <span>{{ job.etaSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.atd && elementDict.atd.viewable" slot="atd" label-width="120px">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              ref="atd"
              :value="job.atd"
              no="46"
              :disabled="!!job.lclMasterUuid || !elementDict.atd.writable"
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @input="atdChange"
              @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
            />
            <span>{{ job.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata && elementDict.ata.viewable" slot="ata" label-width="120px">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              ref="ata"
              v-model="job.ata"
              no="47"
              :disabled="!!job.lclMasterUuid || !elementDict.ata.writable"
              style="flex: 1; width:170px; margin-right: 5px"
              clearable
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @input="ataChange"
              @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
            />
            <span>{{ job.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoCode && elementDict.cargoCode.viewable" slot="cargoCode" label-width="120px">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="48"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            filterable
            :callback-params="{key:'cargoCode'}"
            :default-value="job.cargoCode"
            placeholder=" "
            :class="importDifferenceField.cargoCode ? 'red-border' : ''"
            :disabled="!elementDict.cargoCode.writable"
            @parentCallBack="txtCargoInformationChangeHandler"
          />
          <el-input v-model="job.cargoName" :class="importDifferenceField.cargoName ? 'red-border' : ''" :disabled="!job.cargoCode || !elementDict.cargoCode.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource && elementDict.transportSource.viewable" slot="transportSource" label-width="120px">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransportSource"
            no="transportSource"
            :default-value="job.transportSource"
            :cache="false"
            tag-value="code"
            placeholder=" "
            :disabled="!elementDict.transportSource.writable"
            @parentCallBack="item=>job.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea && elementDict.statisticArea.viewable" slot="statisticArea" label-width="120px">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_StatisticArea"
            no="statisticArea"
            :default-value="job.statisticArea"
            :cache="false"
            tag-value="code"
            placeholder=" "
            :disabled="!elementDict.statisticArea.writable"
            @parentCallBack="item=>job.statisticArea=item.value"
          />
        </el-form-item>
        <el-form-item v-if="isFba" :label="$t('SeaExport.Package')" label-width="120px">
          <cargo-packing-select
            no="packing"
            :default-value="job.packing"
            :callback-params="{}"
            placeholder=" "
            @change="p => {p.key = 'packing';setJobSelectValue(p)}"
          />
        </el-form-item>
        <el-form-item v-if="isFba" :label="$t('SeaExport.HsCode')" label-width="120px">
          <el-input v-model="job.hsCode" :disabled="!elementDict.hsCode.writable" :class="importDifferenceField.hsCode ? 'red-border' : ''" no="hsCode" />
        </el-form-item>
        <el-form-item v-if="isFba" label-width="0">
          <div style="display: flex;justify-content: space-around">
            <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;" no="125">{{ $t('AirExport.WithBattery') }}</el-checkbox>
            <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;" no="126">{{ $t('AirExport.WithMagnet') }}</el-checkbox>
            <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;" no="127">{{ $t('AirExport.Powder') }}</el-checkbox>
            <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;" no="128">{{ $t('AirExport.Liquid') }}</el-checkbox>
          </div>
        </el-form-item>
        <!-- 集装器 -->
        <booking-air-uld-data-grid
          v-if="elementDict.airUlds && elementDict.airUlds.viewable && !job.lclMasterUuid && job.operateType !== 0"
          slot="airUlds"
          :value="airUlds"
          :is-edit="isEdit || !elementDict.airUlds.writable"
          :job="job"
          style="width: 100%"
        />
        <el-form-item v-if="elementDict.warehouseNo && elementDict.warehouseNo.viewable" slot="warehouseNo">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <el-input
            v-model="job.warehouseNo"
            :disabled="!elementDict.warehouseNo.writable"
            no="52"
            type="textarea"
            :rows="5"
            @dblclick.native="showWarehouseDialog"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.viewable" slot="frontEndWarehouseOperation">
          <line-label slot="label" :class="elementDict.frontEndWarehouseOperation.isRequire ? 'blue' : ''" :label="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.label" />
          <cargo-advance-select
            no="frontEndWarehouseOperation"
            :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
            :method-params="{dataType:1, deletionFlag: false, orderType: SystemConstants.AE.code}"
            filterable
            :clearable="true"
            :default-value="job.frontEndWarehouseOperation"
            :disabled="!elementDict.frontEndWarehouseOperation.writable"
            @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.agentInformation && elementDict.agentInformation.viewable" slot="agentInformation">
          <line-label slot="label" :class="elementDict.agentInformation.isRequire ? 'blue' : ''" :label="elementDict.agentInformation.label" />
          <cargo-textarea v-model="job.agentInformation" no="agentInformation" type="textarea" :row="3" :disabled="!elementDict.agentInformation.writable" />
        </el-form-item>
        <el-form-item
          v-if="elementDict.warehouseStatus && elementDict.warehouseStatus.viewable"
          slot="warehouseStatus"
          no="WarehouseState"
        >
          <line-label slot="label" :class="elementDict.warehouseStatus.isRequire ? 'blue' : ''" :label="elementDict.warehouseStatus.label" />
          <el-select
            v-model="job.warehouseStatus"
            :disabled="true || !elementDict.warehouseStatus.writable"
            :placeholder="$t('Message.PleaseSelect')"
            size="mini"
            no="130"
          >
            <el-option
              v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.estimatedDateOfWarehousinge && elementDict.estimatedDateOfWarehousinge.viewable" slot="estimatedDateOfWarehousinge">
          <line-label slot="label" :class="elementDict.estimatedDateOfWarehousinge.isRequire ? 'blue' : ''" :label="elementDict.estimatedDateOfWarehousinge.label" />
          <el-date-picker
            ref="estimatedDateOfWarehousinge"
            v-model="job.estimatedDateOfWarehousinge"
            :disabled="!elementDict.estimatedDateOfWarehousinge.writable"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            clearable
            no="131"
            style="width: 100%"
            :class="importDifferenceField.estimatedDateOfWarehousinge ? 'red-border' : ''"
            @change="changeEstimatedDateOfWarehousinge"
            @blur="()=> { handleBlur('estimatedDateOfWarehousinge', changeEstimatedDateOfWarehousinge, true, true, job) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseInDate && elementDict.warehouseInDate.viewable" slot="warehouseInDate">
          <line-label slot="label" :class="elementDict.warehouseInDate.isRequire ? 'blue' : ''" :label="elementDict.warehouseInDate.label" />
          <el-date-picker
            type="datetime"
            :disabled="true"
            :placeholder="$t('CargoMsg.Cargo_SyncWarehouseData')"
            :value="job.warehouseInDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            clearable
            no="132"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.estimatedDeliveryTime && elementDict.estimatedDeliveryTime.viewable" slot="estimatedDeliveryTime">
          <line-label slot="label" :class="elementDict.estimatedDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryTime.label" />
          <el-date-picker
            ref="estimatedDeliveryTime"
            v-model="job.estimatedDeliveryTime"
            :disabled="!elementDict.estimatedDeliveryTime.writable"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            clearable
            no="133"
            style="width: 100%"
            :class="importDifferenceField.estimatedDeliveryTime ? 'red-border' : ''"
            @change="changeEstimatedDeliveryTime"
            @blur="()=> { handleBlur('estimatedDeliveryTime', changeEstimatedDeliveryTime, true, true, job) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseOutDate && elementDict.warehouseOutDate.viewable" slot="warehouseOutDate">
          <line-label slot="label" :class="elementDict.warehouseOutDate.isRequire ? 'blue' : ''" :label="elementDict.warehouseOutDate.label" />
          <el-date-picker
            ref="warehouseOutDate"
            type="datetime"
            :disabled="true"
            :placeholder="$t('CargoMsg.Cargo_SyncWarehouseData')"
            :value="job.warehouseOutDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            clearable
            no="134"
            style="width: 100%"
            @blur="()=> { handleBlur('warehouseOutDate', null, true, true, job) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.viewable" slot="cargoTerminalOperation">
          <line-label slot="label" :class="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.isRequire ? 'blue' : ''" :label="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.label" />
          <cargo-advance-select
            no="cargoTerminalOperation"
            :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
            :method-params="{dataType:0, deletionFlag: false}"
            filterable
            :clearable="true"
            :default-value="job.cargoTerminalOperation"
            :disabled="!elementDict.cargoTerminalOperation.writable"
            @parentCallBack="p=>{job.cargoTerminalOperation=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.viewable" slot="estimatedDeliveryDate">
          <line-label slot="label" :class="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.label" />
          <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="!isEdit || !job.cargoTerminalOperation || !elementDict.estimatedDeliveryDate.writable" no="estimatedDeliveryDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo && elementDict.customerRefNo.viewable" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <cargo-input v-model="job.customerRefNo" :disabled="!elementDict.customerRefNo.writable" no="53" :trim="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob2 && elementDict.relatedJob2.viewable" slot="relatedJob2">
          <line-label slot="label" :class="elementDict.relatedJob2.isRequire ? 'blue' : ''" :label="elementDict.relatedJob2.label" />
          <el-input v-model="job.relatedJob2" :disabled="!elementDict.relatedJob2.writable" no="54" />
        </el-form-item>
        <el-form-item v-if="elementDict.kcNo && elementDict.kcNo.viewable" slot="kcNo">
          <line-label slot="label" :class="elementDict.kcNo.isRequire ? 'blue' : ''" :label="elementDict.kcNo.label" />
          <el-input v-model="job.kcNo" :disabled="!elementDict.kcNo.writable" no="55" />
        </el-form-item>
        <el-form-item v-if="elementDict.poNo && elementDict.poNo.viewable" slot="poNo" :class="poNoRed?'poNoClass':''">
          <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
          <el-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="!elementDict.poNo.writable" no="56" />
          <cargo-project-select
            v-if="openProjectConfig"
            no="57"
            :default-value="job.poNo"
            :customer-id="job.customerId"
            :is-linked="isProjectLinkedCustomer"
            placeholder=" "
            @change="
              p => {
                job.poNo = p.value
                job.projectName = p.projectName
                changeProject()
              }
            "
          />
        </el-form-item>
        <el-form-item
          v-if="elementDict.projectName && elementDict.projectName.viewable && openProjectConfig"
          slot="projectName"
        >
          <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
          <el-input v-model="job.projectName" no="58" :disabled="true" />
        </el-form-item>
        <el-form-item
          v-if="elementDict.projectBatch && elementDict.projectBatch.viewable && openProjectConfig"
          slot="projectBatch"
        >
          <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
          <el-input v-model="job.projectBatch" :disabled="!elementDict.projectBatch.writable" no="59" />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL && elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            no="60"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            filterable
            :clearable="false"
            :class="importDifferenceField.paymentTermMBL ? 'red-border' : ''"
            :default-value="job.paymentTermMBL"
            :disabled="!elementDict.paymentTermMBL.writable"
            @parentCallBack="p => {pm.paymentTermMBLChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermHBL && elementDict.paymentTermHBL.viewable" slot="paymentTermHBL">
          <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
          <cargo-advance-select
            no="61"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            :default-value="job.paymentTermHBL"
            :class="importDifferenceField.paymentTermHBL ? 'red-border' : ''"
            placeholder=" "
            :disabled="!elementDict.paymentTermHBL.writable"
            @parentCallBack="p => {pm.paymentTermHBLChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cabinReq && elementDict.cabinReq.viewable" slot="cabinReq">
          <line-label slot="label" :class="elementDict.cabinReq.isRequire ? 'blue' : ''" :label="elementDict.cabinReq.label" />
          <el-input v-model="job.cabinReq" :disabled="!elementDict.cabinReq.writable" no="62" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadReq && elementDict.loadReq.viewable" slot="loadReq">
          <line-label slot="label" :class="elementDict.loadReq.isRequire ? 'blue' : ''" :label="elementDict.loadReq.label" />
          <el-input v-model="job.loadReq" :disabled="!elementDict.loadReq.writable" no="63" />
        </el-form-item>
        <el-form-item v-if="elementDict.docReq && elementDict.docReq.viewable" slot="docReq">
          <line-label slot="label" :class="elementDict.docReq.isRequire ? 'blue' : ''" :label="elementDict.docReq.label" />
          <el-input v-model="job.docReq" :disabled="!elementDict.docReq.writable" no="64" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoType && elementDict.cargoType.viewable" slot="cargoType">
          <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
          <el-select v-model="job.cargoType" :disabled="!elementDict.cargoType.writable" :class="importDifferenceField.cargoType ? 'red-border' : ''" filterable no="135" @change="onCargoTypeChagne">
            <el-option
              v-for="(item,index) in cargoType4JobSelect"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.salesChannel && elementDict.salesChannel.viewable" slot="salesChannel">
          <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
          <el-input
            v-model="job.salesChannel"
            :disabled="true"
            no="136"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.trustFromJob && elementDict.trustFromJob.viewable" slot="trustFromJob">
          <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
          <el-input
            v-model="job.trustFromJob"
            :disabled="true"
            no="trustFromJob"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.viewable" slot="relatedJob">
          <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
          <el-input
            v-model="job.relatedJob"
            :disabled="true"
            no="relatedJob"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.channelNo && elementDict.channelNo.viewable && showChannelNo" slot="channelNo">
          <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
          <el-input v-model="job.channelNo" :disabled="true" no="137" />
        </el-form-item>
        <template v-if="elementDict.measurements && elementDict.measurements.viewable" slot="measurements">
          <el-form-item>
            <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
            <el-button
              no="GetGoodsInformation"
              :disabled="!isEdit || !elementDict.measurements.writable"
              type="primary"
              @click="pm.getCargoInformation()"
            >
              {{ $t('SeaExport.GetGoodsInformation') }}
            </el-button>
            <el-tooltip
              effect="light"
              :content="$t('SeaExport.GetGoodsInformationTip')"
              placement="right-end"
              disabled
            >
              <i style="cursor:pointer;margin-left:4px;color:#1989fa;" class="el-icon-question" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="" class="auto-width">
            <el-input
              v-model="job.measurements"
              no="66"
              type="textarea"
              :disabled="!elementDict.measurements.writable"
              :rows="3"
              @change="p=>{pm.measurementsChangeHandler(p)}"
              @dblclick.native="showAdvanceTextDialog(elementDict.measurements.label,job.measurements,val=>{pm.doMeasurementsChangeHandler(val)})"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.selling && elementDict.selling.viewable" slot="selling">
          <line-label slot="label" :class="elementDict.selling.isRequire ? 'blue' : ''" :label="elementDict.selling.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.selling" :disabled="job.sellingPriceLock || !isEdit || !elementDict.selling.writable" style="width:120px;margin-right: 5px;" no="67" @change="sellingOrBuyingChangeHandler(true, 3)" />
            <cargo-advance-select
              filterable
              no="sellingCurrency"
              :placeholder="' '"
              :select-type="selectTypeNames.basic_data_Currency"
              :disabled="job.sellingPriceLock || !isEdit || !elementDict.selling.writable"
              :default-value="job.sellingCurrency"
              style="flex:1"
              :clearable="false"
              @parentCallBack="p=>{job.sellingCurrency=p.code;sellingOrBuyingChangeHandler(false, 1)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.buying && elementDict.buying.viewable" slot="buying">
          <line-label slot="label" :class="elementDict.buying.isRequire ? 'blue' : ''" :label="elementDict.buying.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.buying" :disabled="job.purchasePriceLock || !isEdit || !elementDict.buying.writable" style="width:120px;margin-right: 5px;" no="68" @change="sellingOrBuyingChangeHandler(true, 3)" />
            <cargo-advance-select
              filterable
              no="buyingCurrency"
              :placeholder="' '"
              :select-type="selectTypeNames.basic_data_Currency"
              :disabled="job.purchasePriceLock || !isEdit || !elementDict.buying.writable"
              :default-value="job.buyingCurrency"
              :clearable="false"
              style="flex:1"
              @parentCallBack="p=>{job.buyingCurrency=p.code;sellingOrBuyingChangeHandler(false, 1)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.sellPriceType && elementDict.sellPriceType.viewable" slot="sellPriceType" :label="elementDict.sellPriceType.label">
          <el-select
            v-model="job.sellPriceType"
            :disabled="job.purchasePriceLock || !isEdit || !elementDict.sellPriceType.writable"
            :placeholder="$t('Message.PleaseSelect')"
            size="mini"
            no="sellPriceType"
            @change="sellingOrBuyingChangeHandler(false, 2)"
          >
            <el-option
              v-for="(item,index) in AirExportConstants.SELL_BUY_PRICE"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.buyPriceType && elementDict.buyPriceType.viewable" slot="buyPriceType" :label="elementDict.buyPriceType.label">
          <el-select
            v-model="job.buyPriceType"
            :disabled="job.purchasePriceLock || !isEdit || !elementDict.buyPriceType.writable"
            :placeholder="$t('Message.PleaseSelect')"
            size="mini"
            no="buyPriceType"
            @change="sellingOrBuyingChangeHandler(false, 2)"
          >
            <el-option
              v-for="(item,index) in AirExportConstants.SELL_BUY_PRICE"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.protocolType && elementDict.protocolType.viewable" slot="protocolType">
          <line-label slot="label" :class="elementDict.protocolType.isRequire ? 'blue' : ''" :label="elementDict.protocolType.label" />
          <cargo-advance-select
            no="69"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.local_cache_SystemConstants$PROTOCOL_TYPES"
            callback-method-type="value"
            :default-value="job.protocolType || 'none'"
            :tag-name="isZh?'chineseName':'englishName'"
            :fields="['chineseName']"
            :callback-params="{key:'protocolType'}"
            :disabled="!elementDict.protocolType.writable"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.operationContent && elementDict.operationContent.viewable" slot="operationContent">
          <line-label slot="label" :class="elementDict.operationContent.isRequire ? 'blue' : ''" :label="elementDict.operationContent.label" />
          <el-tooltip :content="job.operationContent" placement="left">
            <div slot="content" v-html="job.operationContent ? job.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')" />
            <el-input
              no="70"
              :disabled="!elementDict.operationContent.writable"
              :value="job.operationContent"
              :placeholder="viewStatus ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
              type="textarea"
              :rows="4"
              @dblclick.native="selectOperationReqDialog.value=job.operationContent;selectOperationReqDialog.visible=!viewStatus"
            />
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.temperatureRequirement && elementDict.temperatureRequirement.viewable" slot="temperatureRequirement">
          <line-label slot="label" :class="elementDict.temperatureRequirement.isRequire ? 'blue' : ''" :label="elementDict.temperatureRequirement.label" />
          <cargo-advance-select
            no="temperatureRequirement"
            :disabled="!elementDict.temperatureRequirement.writable"
            :cache="false"
            filterable
            allow-create
            tag-name="code"
            tag-value="code"
            :static-options="temperatureRequirementDownList"
            :default-value="job.temperatureRequirement"
            @parentCallBack="p=>{job.temperatureRequirement=p.code}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.wood && elementDict.wood.viewable" slot="wood">
          <line-label slot="label" :class="elementDict.wood.isRequire ? 'blue' : ''" :label="elementDict.wood.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="147"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.local_cache_AirExportConstants$WOOD"
              :default-value="job.wood"
              :fields="['chineseName']"
              :disabled="!elementDict.wood.writable"
              @parentCallBack="onWoodOrNotWoodChagne"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.hazardousGoodsOption && elementDict.hazardousGoodsOption.viewable" slot="wood">
          <line-label slot="label" :class="elementDict.hazardousGoodsOption.isRequire ? 'blue' : ''" :label="elementDict.hazardousGoodsOption.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="148"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION"
              :default-value="job.hazardousGoodsOption"
              :fields="['chineseName']"
              :disabled="!elementDict.hazardousGoodsOption.writable"
              @parentCallBack="onHazardousGoodsOptionChagne"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.handlingInformation && elementDict.handlingInformation.viewable" slot="wood">
          <line-label slot="label" :class="elementDict.handlingInformation.isRequire ? 'blue' : ''" :label="elementDict.handlingInformation.label" />
          <el-input
            v-model="job.handlingInformation"
            no="149"
            :readonly="true"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.handlingInformation'),job.handlingInformation,val=>{job.handlingInformation=val})"
          />
        </el-form-item>
        <el-form-item v-if="isFba" :label="$t('SeaExport.OperationTips')">
          <el-input
            v-model="job.operationTips"
            no="operationTips"
            type="textarea"
            :rows="5"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.txtSalesOffice && elementDict.txtSalesOffice.viewable" slot="txtSalesOffice">
          <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
          <el-input v-model="txtSalesOffice" :class="importDifferenceField.salesOffice ? 'red-border' : ''" no="71" :disabled="true" />
        </el-form-item>
        <el-form-item v-show="elementDict.sales && elementDict.sales.viewable" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire || job.cargoSource !== 'NC' ? 'blue' : ''" :label="elementDict.sales.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-user-select
              ref="sales"
              no="72"
              :disabled="!saleEnabled || !elementDict.sales.writable"
              :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales',active:true}"
              :default-value="job.sales||''"
              :static-options="salesList"
              :placeholder="salesPrompt||' '"
              :class="importDifferenceField.sales ? 'red-border' : ''"
              style="width: 130px;flex: 1"
              @change="p=>{pm.salesChangeHandler(p);}"
            />&nbsp;
            <el-checkbox v-model="job.provisioned" no="73" style="margin-left: 5px" :disabled="true">{{ $t('SeaExport.Accrued') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId && elementDict.cargoSalesId.viewable" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="74"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="job.cargoSalesId||''"
            :disabled="!elementDict.cargoSalesId.writable"
            placeholder=" "
            :static-options="cargoSalesList"
            :class="importDifferenceField.cargoSalesId ? 'red-border' : ''"
            @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment && elementDict.salesDepartment.viewable" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire || job.cargoSource !== 'NC' ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            no="75"
            :disabled="!job.sales || !elementDict.salesDepartment.writable"
            :enables="true"
            :sales-id="Number(job.sales)"
            :office-id="Number(job.salesOffice)"
            :department-id="Number(job.salesDepartment)"
            :class="importDifferenceField.salesDepartment ? 'red-border' : ''"
            @change="p=>{pm.departmentChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice && elementDict.opOffice.viewable" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-office-select
            no="76"
            :disabled="viewStatus || opOfficeDisabled || !elementDict.opOffice.writable"
            :office-id="Number(job.opOffice)"
            placeholder=" "
            :is-regional-commission="isRegionalCommission"
            :class="importDifferenceField.opOffice ? 'red-border' : ''"
            @change="p=>{pm.opOfficeChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opDepartment && elementDict.opDepartment.viewable" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            no="77"
            :disabled="!opDeptEnabled || !elementDict.opDepartment.writable"
            :enables="true"
            :office-id="Number(job.opOffice)"
            :department-id="Number(job.opDepartment)"
            placeholder=" "
            :class="importDifferenceField.opDepartment ? 'red-border' : ''"
            @change="p=>{job.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op && elementDict.op.viewable" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select
            no="78"
            :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
            :default-value="job.op||''"
            :disabled="!elementDict.op.writable"
            :static-options="userPortRoleData.op"
            placeholder=" "
            :class="importDifferenceField.op ? 'red-border' : ''"
            @change="p=>{pm.opChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice && elementDict.csrOffice.viewable" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(job.csrOffice)"
            :class="importDifferenceField.csrOffice ? 'red-border' : ''"
            @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment && elementDict.csrDepartment.viewable" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :office-id="Number(job.csrOffice)"
            :enables="true"
            :department-id="Number(job.csrDepartment)"
            :class="importDifferenceField.csrDepartment ? 'red-border' : ''"
            @change="p=>{job.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csr && elementDict.csr.viewable" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            no="79"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            :disabled="!elementDict.csr.writable"
            placeholder=" "
            :static-options="userPortRoleData.csr"
            :class="importDifferenceField.csr ? 'red-border' : ''"
            @change="p=>{pm.csrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice && elementDict.dcOffice.viewable" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(job.dcOffice)"
            :class="importDifferenceField.dcOffice ? 'red-border' : ''"
            @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment && elementDict.dcDepartment.viewable" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :office-id="Number(job.dcOffice)"
            :enables="true"
            :department-id="Number(job.dcDepartment)"
            :class="importDifferenceField.dcDepartment ? 'red-border' : ''"
            @change="p=>{job.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dc && elementDict.dc.viewable" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select
            no="80"
            :method-params="{category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            :disabled="!elementDict.dc.writable"
            placeholder=" "
            :static-options="userPortRoleData.doc"
            :class="importDifferenceField.dc ? 'red-border' : ''"
            @change="p=>{pm.dcChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.viewable" slot="plannerOffice">
          <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
          <cargo-office-select
            no="plannerOffice"
            :disabled="true"
            :office-id="Number(job.plannerOffice)"
            :class="importDifferenceField.plannerOffice ? 'red-border' : ''"
            @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.viewable" slot="plannerDepartment">
          <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
          <cargo-department-select
            no="plannerDepartment"
            :office-id="Number(job.plannerOffice)"
            :enables="true"
            :department-id="Number(job.plannerDepartment)"
            :class="importDifferenceField.plannerDepartment ? 'red-border' : ''"
            @change="p=>{job.plannerDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.planner && elementDict.planner.viewable" slot="planner">
          <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
          <cargo-user-select
            no="81"
            :method-params="{officeId:job.opOffice,category:'role',shape:'airline'}"
            :default-value="job.planner||''"
            placeholder=" "
            :disabled="!elementDict.planner.writable"
            :static-options="userPortRoleData.airline"
            :class="importDifferenceField.planner ? 'red-border' : ''"
            @change="p=>{pm.plannerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP && elementDict.siteOP.viewable" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            no="82"
            :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
            :default-value="job.siteOP||''"
            placeholder=" "
            :disabled="!elementDict.siteOP.writable"
            :static-options="userPortRoleData.siteOp"
            @change="p=>{pm.siteOpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.overseaOp && elementDict.overseaOp.viewable" slot="overseaOp">
          <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
          <cargo-user-select
            ref="overseaOp"
            no="83"
            :disabled="!elementDict.overseaOp.writable"
            :default-value="job.overseaOp||''"
            :method-params="{category:'role',shape:'overseaOp'}"
            :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
            :merge-load="true"
            placeholder=" "
            @change="p=>{job.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId1 && elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :disabled="viewStatus || !elementDict.userDefinedRoleId1.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :merge-load="true"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole1"
            @change="p=>{pm.userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId2 && elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :disabled="viewStatus || !elementDict.userDefinedRoleId2.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :merge-load="true"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole2"
            @change="p=>{pm.userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
          <micro-app
            name="child-user-defined-role-ae-userDefinedRoleId3"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div>
        <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
          <micro-app
            name="child-user-defined-role-ae-userDefinedRoleId4"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div> -->
        <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="viewStatus || !elementDict.userDefinedRoleId3.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="job.userDefinedRoleId3||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole3"
            @change="p=>{pm.userDefinedRoleId3Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="viewStatus || !elementDict.userDefinedRoleId4.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="job.userDefinedRoleId4||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole4"
            @change="p=>{pm.userDefinedRoleId4Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :disabled="viewStatus || !elementDict.userDefinedRoleId5.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="job.userDefinedRoleId5||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId5Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6 &&elementDict.userDefinedRoleId6.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :disabled="viewStatus || !elementDict.userDefinedRoleId6.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="job.userDefinedRoleId6||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId6Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7 &&elementDict.userDefinedRoleId7.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :disabled="viewStatus || !elementDict.userDefinedRoleId7.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="job.userDefinedRoleId7||''"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId7Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
            :disabled="viewStatus || !elementDict.userDefinedRoleId8.writable"
            :multiple="true"
            :merge-load="true"
            :placeholder="viewStatus ? ' ' : ''"
            @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <div v-show="elementDict.satisfiedRequests && elementDict.satisfiedRequests.viewable" slot="satisfiedRequests">
          <special-requests-grid v-model="job.satisfiedRequests" no="satisfiedRequests" :customer-id="job.customerId" :lob="job.lob" :job="job" :is-edit="!viewStatus || !elementDict.satisfiedRequests.writable" />
        </div>
        <el-form-item v-if="elementDict.hsCode && elementDict.hsCode.viewable && !isFba" slot="hsCode" style="margin-top: 10px">
          <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <el-input v-model="job.hsCode" :disabled="!elementDict.hsCode.writable" :class="importDifferenceField.hsCode ? 'red-border' : ''" no="84" />
        </el-form-item>
        <el-form-item v-if="elementDict.remarks && elementDict.remarks.viewable" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <el-input
            v-model="job.remarks"
            :disabled="!elementDict.remarks.writable"
            no="85"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,job.remarks,val=>{job.remarks=val})"
          />
        </el-form-item>
        <!-- FBA相关信息-->
        <div v-if="isFba" class="section form-column">
          <el-form
            :disabled="viewStatus"
            label-width="120px"
            label-position="right"
          >
            <el-form-item v-if="!isEdit" :label="$t('AirExport.ServiceChannel')">
              <cargo-advance-select
                no="serviceChannel"
                disabled
                :select-type="selectTypeNames.basic_data_FbaChannel"
                filterable
                :method-params="{shippingType: fbaJob.shippingType, active: true}"
                :clearable="true"
                :default-value="fbaJob.serviceChannel"
                @parentCallBack="p=>{fbaJob.serviceChannel=p.value;}"
              />
            </el-form-item>
            <el-form-item v-if="isEdit" :label="$t('AirExport.ServiceChannel')">
              <el-select v-model="fbaJob.serviceChannel" filterable clearable no="138" @change="changeServiceChannel">
                <el-option
                  v-for="(item,index) in channel4JobSelect"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelName"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('AirExport.EstimatedStorageGoodArrivalTime') }}</span>
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="datetime"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @change="preWarehousingChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ExpectedTimeIntoAmazonWarehouse')">
              <el-date-picker
                v-model="fbaJob.preAmazonWhTime"
                no="preAmazonWhTime"
                :disabled="viewStatus"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
              <div style="display: flex; flex: 1;">
                <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                  <el-cascader
                    v-model="fbaJob.warehouseCode"
                    style="padding-right: 2px;"
                    :options="destinations"
                    filterable
                    :clearable="true"
                    no="139"
                    @focus="JobUtils.focusWarehouseCode(fbaJob)"
                    @blur="JobUtils.blurWarehouseCode(fbaJob)"
                    @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);changeWarehouseCode}"
                  />
                </el-tooltip>
                <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('AirExport.RemoteWarehouse') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DestinationCountry')">
              <el-input v-model="fbaJob.country" :disabled="true" no="country" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ZipCode')">
              <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.DestinationDeliveryMethod')">
              <el-select v-model="fbaJob.destinationDistribution" no="destinationDistribution" filterable @change="destinationDistributionChange">
                <el-option
                  v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                  :key="index"
                  :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierCompany')">
              <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                <el-option
                  v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierNumber')">
              <el-input v-model="fbaJob.expressNo" no="expressNo" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.POOriginalOrderNumber')">
              <el-input v-model="fbaJob.poNumber" no="poNumber" />
            </el-form-item>
            <el-form-item :label="'Shipment Id'">
              <el-input v-model="fbaJob.shipmentId" no="shipmentId" />
            </el-form-item>
            <el-form-item :label="'Reference Id'">
              <el-input v-model="fbaJob.referenceId" no="referenceId" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.EORIBusinessNumber')">
              <el-input v-model="fbaJob.eoriNo" no="eoriNo" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.VATTaxNumber')">
              <el-input v-model="fbaJob.vatNo" no="vatNo" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.VATRegistrationCountry')">
              <cargo-advance-select
                no="taxRegisterCountry"
                :select-type="selectTypeNames.basic_data_Country"
                filterable
                :callback-params="{key:'taxRegisterCountry'}"
                callback-method-type="value"
                :default-value="fbaJob.taxRegisterCountry"
                @parentCallBack="p=>{fbaJob.taxRegisterCountry = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.VATRegistrationAddress')">
              <el-input v-model="fbaJob.taxRegisterAddress" no="taxRegisterAddress" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.VATCompanyEnglishName')">
              <el-input v-model="fbaJob.taxCompany" no="taxCompany" />
            </el-form-item>

            <hr style="margin-top: 20px;margin-bottom: 20px;">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="job.estWarehouseDeliveryTime"
                no="estWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="job.actWarehouseDeliveryTime"
                no="actWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="job.estGoodsDeliveryTime"
                no="estGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="job.actGoodsDeliveryTime"
                no="actGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.EstimatedDeliveryTime')">
              <el-date-picker
                v-model="job.estDeliveryTime"
                no="estDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ActualDeliveryTime')">
              <el-date-picker
                v-model="job.actDeliveryTime"
                no="actDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
        <el-form-item v-if="elementDict.userDefinedField1 && elementDict.userDefinedField1.viewable" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="job.userDefinedField1"
            :disabled="!elementDict.userDefinedField1.writable"
            no="86"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2 && elementDict.userDefinedField2.viewable" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="job.userDefinedField2"
            :disabled="!elementDict.userDefinedField2.writable"
            no="87"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3 && elementDict.userDefinedField3.viewable" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="job.userDefinedField3"
            :disabled="!elementDict.userDefinedField3.writable"
            no="88"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4 && elementDict.userDefinedField4.viewable" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="job.userDefinedField4"
            :disabled="!elementDict.userDefinedField4.writable"
            no="89"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.viewable" slot="exportControlledProduct">
          <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
          <el-select
            v-model="job.exportControlledProduct"
            no="exportControlledProduct"
            :disabled="!isEdit || !elementDict.exportControlledProduct.writable"
            :placeholder="''"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.viewable" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="job.taxNature"
            :disabled="!elementDict.taxNature.writable"
            no="taxNature"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.boardSales && elementDict.boardSales.viewable" slot="boardSales" :label="$t('SeaExport.BoardSales')">
          <line-label slot="label" :class="elementDict.boardSales.isRequire ? 'blue' : ''" :label="elementDict.boardSales.label" />
          <el-input v-model="job.boardSales" :disabled="true" no="BoardSales" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.boardCsr && elementDict.boardCsr.viewable" slot="boardCsr" :label="$t('SeaExport.BoardCsr')">
          <line-label slot="label" :class="elementDict.boardCsr.isRequire ? 'blue' : ''" :label="elementDict.boardCsr.label" />
          <el-input v-model="job.boardCsr" :disabled="true" no="BoardCsr" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.boardSite && elementDict.boardSite.viewable" slot="boardSite" :label="$t('SeaExport.BoardSite')">
          <line-label slot="label" :class="elementDict.boardSite.isRequire ? 'blue' : ''" :label="elementDict.boardSite.label" />
          <el-input v-model="job.boardSite" :disabled="true" no="BoardSite" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.arrivalMethod && elementDict.arrivalMethod.viewable" slot="arrivalMethod" :label="$t('SeaExport.ArrivalMethod')">
          <line-label slot="label" :class="elementDict.arrivalMethod.isRequire ? 'blue' : ''" :label="elementDict.arrivalMethod.label" />
          <el-select v-model="job.arrivalMethod" :disabled="true" :placeholder="$t('Message.PleaseSelect')" size="mini" no="ArrivalMethod">
            <el-option
              v-for="(item,index) in AirExportConstants.ARRIVAL_METHOD"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.flightLabel && elementDict.flightLabel.viewable" slot="flightLabel" :label="$t('SeaExport.FlightLabel')">
          <line-label slot="label" :class="elementDict.flightLabel.isRequire ? 'blue' : ''" :label="elementDict.flightLabel.label" />
          <el-select v-model="job.flightLabel" :disabled="true" :placeholder="$t('Message.PleaseSelect')" size="mini" no="FlightLabel">
            <el-option
              v-for="(item,index) in AirExportConstants.AIR_FLIGHT_LABEL"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <div v-if="showGoodsInfo" slot="goodsInfo" class="goods-info" style="width: 1100px">
          <el-form-item class="auto-width">
            <div style="display: flex">
              <div style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:188px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('queryJob.Density') }}kg/m³</div>
                <div v-if="isFba" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.VolumetricWeight') }}KGS</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Size') }}CM</div>
              </div>
              <div v-if="showImperialButton && viewStatus" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;padding-left: 50px">
                {{ $t('CargoMsg.Cargo_ImperialUnits') }}
                <div :class="isOpenImperial?'el-switch is-checked':'el-switch'">
                  <span class="el-switch__core" style="width: 40px;" @click="isOpenImperial = !isOpenImperial" />
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoContract && elementDict.goodsInfoContract.viewable" slot="goodsInfoContract" class="goods-info" style="width: 1500px">
          <el-form-item class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoContract.isRequire ? 'blue' : ''" :label="$t('SeaExport.Consignation')" />
            <auto-number-input
              v-model="job.quantityContract"
              no="90"
              :precision="0"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              style="margin-left: 0"
              :class="importDifferenceField.quantityContract ? 'red-border' : ''"
              @change="calcEstVolumetricAndChargeWeight(false)"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightContractImperial"
              no="weightContractImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.weightContract ? 'red-border' : ''"
              @change="weightContractImperialChange()"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeContractImperial"
              no="cubAgeContractImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.cubageContract ? 'red-border' : ''"
              @change="cubAgeContractImperialChange();"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightImperial"
              no="chargeWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
              :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightContract"
              no="91"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.weightContract ? 'red-border' : ''"
              @change="weightContractChange(true);calcEstVolumetricAndChargeWeight(false)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageContract"
              no="92"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.cubageContract ? 'red-border' : ''"
              @change="cubageContractChange(true);calcEstVolumetricAndChargeWeight(false)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeight"
              no="93"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
              @change="pm.chargeWeightImperialChange('chargeWeight', 'chargeWeightImperial')"
            />
            <auto-number-input
              v-model="job.densityContract"
              :precision="3"
              :min="0"
              no="140"
              :disabled="!elementDict.goodsInfoContract.writable"
              :class="importDifferenceField.densityContract ? 'red-border' : ''"
            />
            <auto-number-input
              v-if="isFba"
              v-model="job.volumetricWeightContract"
              no="80"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="calcEstVolumetricAndChargeWeight(false, job.volumetricWeightContract)"
            />
            <el-input v-model="job.commissionDimensions" no="commissionDimensions" style="width: 200px;padding-right: 5px" :disabled="!elementDict.goodsInfoContract.writable" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(1)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoBooking && elementDict.goodsInfoBooking.viewable" slot="goodsInfoBooking" class="goods-info" style="width: 1500px">
          <el-form-item :label="$t('SeaExport.Booking')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoBooking.isRequire ? 'blue' : ''" :label="$t('SeaExport.Booking')" />
            <auto-number-input
              v-model="job.quantityBooking"
              no="94"
              :precision="0"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              style="margin-left: 0"
              :class="importDifferenceField.quantityBooking ? 'red-border' : ''"
              @change="pm.weightCubageChangeHandler('quantityBooking');calcEstVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightBookingImperial"
              no="weightBookingImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.weightBooking ? 'red-border' : ''"
              @change="pm.weightCubAgeImperialChangeHandler('weightBooking');"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeBookingImperial"
              no="cubAgeBookingImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.cubageBooking ? 'red-border' : ''"
              @change="pm.weightCubAgeImperialChangeHandler('cubageBooking');"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightBookingImperial"
              no="chargeWeightBookingImperial"
              :precision="3"
              :min="0"
              :disabled="true"
              :class="importDifferenceField.chargeWeightBooking ? 'red-border' : ''"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightBooking"
              no="95"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.weightBooking ? 'red-border' : ''"
              @change="pm.doWeightCubAgeChangeHandler('weightBooking');calcEstVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageBooking"
              no="96"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.cubageBooking ? 'red-border' : ''"
              @change="pm.doWeightCubAgeChangeHandler('cubageBooking');calcEstVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightBooking"
              no="97"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.chargeWeightBooking ? 'red-border' : ''"
              @change="pm.chargeWeightImperialChange('chargeWeightBooking', 'chargeWeightBookingImperial')"
            />
            <auto-number-input
              v-model="job.densityBooking"
              :precision="3"
              :min="0"
              no="141"
              :disabled="!elementDict.goodsInfoBooking.writable"
              :class="importDifferenceField.densityBooking ? 'red-border' : ''"
            />
            <auto-number-input
              v-if="isFba"
              v-model="job.volumetricWeightBooking"
              no="81"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="calcEstVolumetricAndChargeWeight(true, job.volumetricWeightBooking)"
            />
            <el-input v-model="job.measurements" no="measurements" style="width: 200px;padding-right: 5px" :disabled="!elementDict.goodsInfoBooking.writable" @input="pm.weightCubageChangeHandler('measurements')" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(2)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoActual && elementDict.goodsInfoActual.viewable" slot="goodsInfoActual" class="goods-info" style="width: 1500px">
          <el-form-item :label="$t('SeaExport.FrontCabinActual')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoActual.isRequire ? 'blue' : ''" :label="$t('SeaExport.FrontCabinActual')" />
            <auto-number-input
              v-model="job.quantityActual"
              no="98"
              :precision="0"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              style="margin-left: 0"
              :class="importDifferenceField.quantityActual ? 'red-border' : ''"
              @change="pm.weightCubageChangeHandler('quantityActual');quantityActualChange()"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightActualImperial"
              no="weightActualImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.weightActual ? 'red-border' : ''"
              @change="weightActualImperialChange"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeActualImperial"
              no="cubAgeActualImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.cubageActual ? 'red-border' : ''"
              @change="cubAgeActualImperialChange"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cWeightImperial"
              no="cWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
              :class="importDifferenceField.cWeight ? 'red-border' : ''"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightActual"
              no="99"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.weightActual ? 'red-border' : ''"
              @change="weightActualChange(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageActual"
              no="100"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.cubageActual ? 'red-border' : ''"
              @change="cubageActualChange(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cWeight"
              no="101"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.cWeight ? 'red-border' : ''"
              @change="isFba ? changeChargeWeight : pm.weightCubageChangeHandler('chargeWeightActual')"
            />
            <auto-number-input
              v-model="job.densityActual"
              :precision="3"
              :min="0"
              no="142"
              :disabled="!elementDict.goodsInfoActual.writable"
              :class="importDifferenceField.densityActual ? 'red-border' : ''"
            />
            <auto-number-input
              v-if="isFba"
              v-model="job.volumetricWeight"
              no="82"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="changeVolumetricWeight"
            />
            <el-input v-model="job.dimensionsActual" no="dimensionsActual" style="width: 200px;padding-right: 5px" :disabled="!elementDict.goodsInfoActual.writable" @input="pm.weightCubageChangeHandler('dimensionsActual')" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(3)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoDocument && elementDict.goodsInfoDocument.viewable && job.operateType!==0" slot="goodsInfoDocument" class="goods-info" style="width: 1500px">
          <el-form-item :label="$t('SeaExport.Documentation')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoDocument.isRequire ? 'blue' : ''" :label="$t('SeaExport.Documentation')" />
            <auto-number-input
              v-model="mawbDoc.quantity"
              no="102"
              :precision="0"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              style="margin-left: 0"
              @change="pm.weightCubageChangeHandler('quantityMBL');calcActVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="mawbDoc.weightImperial"
              no="weightImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              @change="pm.weightCubAgeImperialChangeHandler('weightMBL');"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="mawbDoc.cubAgeImperial"
              no="cubAgeImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              @change="pm.weightCubAgeImperialChangeHandler('cubageMBL');"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="mawbDoc.chargeWeightImperial"
              no="chargeWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="mawbDoc.weight"
              no="103"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              @change="pm.doWeightCubAgeChangeHandler('weightMBL');calcActVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="mawbDoc.cubage"
              no="104"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              @change="pm.doWeightCubAgeChangeHandler('cubageMBL');calcActVolumetricAndChargeWeight(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="mawbDoc.cWeight"
              no="105"
              :precision="3"
              :min="0"
              :disabled="!elementDict.goodsInfoDocument.writable"
              @change="pm.doWeightCubAgeChangeHandler('chargeWeightMBL')"
            />
            <auto-number-input
              v-model="job.densityDoc"
              :precision="3"
              :min="0"
              no="143"
              :disabled="!elementDict.goodsInfoDocument.writable"
              :class="importDifferenceField.densityDoc ? 'red-border' : ''"
            />
            <auto-number-input
              v-if="isFba"
              v-model="mawbDoc.volumetricWeight"
              no="82"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="calcActVolumetricAndChargeWeight(true, mawbDoc.volumetricWeight)"
            />
            <el-input v-model="job.docDimensions" no="docDimensions" style="width: 200px;padding-right: 5px" :disabled="!elementDict.goodsInfoDocument.writable" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(6)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <div v-if="elementDict.quantityStation && elementDict.quantityStation.viewable" slot="quantityStation" class="goods-info" style="width: 1500px">
          <el-form-item :label="$t('SeaExport.FreightStation')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.quantityStation.isRequire ? 'blue' : ''" :label="$t('SeaExport.FreightStation')" />
            <auto-number-input
              v-model="job.quantityStation"
              no="150"
              :precision="0"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              style="margin-left: 0"
              :class="importDifferenceField.quantityStation ? 'red-border' : ''"
              @change="pm.weightCubageChangeHandler('quantityStation');calcStationVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightStationImperial"
              no="weightStationImperial"
              :precision="2"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              :class="importDifferenceField.weightStation ? 'red-border' : ''"
              @change="weightStationImperialChange();"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeStationImperial"
              no="cubAgeStationImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              :class="importDifferenceField.cubageStation ? 'red-border' : ''"
              @change="cubAgeStationImperialChange();"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightStationImperial"
              no="chargeWeightStationImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightStation"
              no="151"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              :class="importDifferenceField.weightStation ? 'red-border' : ''"
              @change="weightStationChange(true);calcStationVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageStation"
              no="152"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              :class="importDifferenceField.cubageStation ? 'red-border' : ''"
              @change="cubageStationChange(true);calcStationVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightStation"
              no="153"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              @change="pm.chargeWeightImperialChange('chargeWeightStation', 'chargeWeightStationImperial')"
            />
            <auto-number-input
              v-model="job.densityStation"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantityStation.writable"
              no="154"
            />
            <auto-number-input
              v-if="isFba"
              v-model="job.volumetricWeightStation"
              no="155"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="calcStationVolumetricAndChargeWeight(job.volumetricWeightStation)"
            />
            <el-input v-model="job.freightStationDimensions" no="freightStationDimensions" style="width: 200px;padding-right: 5px" :disabled="!elementDict.quantityStation.writable" @input="pm.weightCubageChangeHandler('freightStationDimensions')" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(4)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <div v-if="elementDict.quantitySigning && elementDict.quantitySigning.viewable" slot="quantitySigning" class="goods-info" style="width: 1500px">
          <el-form-item :label="$t('SeaExport.SignBill')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.quantitySigning.isRequire ? 'blue' : ''" :label="$t('SeaExport.SignBill')" />
            <auto-number-input
              v-model="job.quantitySigning"
              no="156"
              :precision="0"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              style="margin-left: 0"
              :class="importDifferenceField.quantitySigning ? 'red-border' : ''"
              @change="pm.weightCubageChangeHandler('quantitySigning');calcSigningVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightSigningImperial"
              no="weightSigningImperial"
              :precision="2"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.weightSigning ? 'red-border' : ''"
              @change="weightSigningImperialChange();"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeSigningImperial"
              no="cubAgeSigningImperial"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.cubageSigning ? 'red-border' : ''"
              @change="cubAgeSigningImperialChange();"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightSigningImperial"
              no="chargeWeightSigningImperial"
              :precision="3"
              :min="0"
              :disabled="true"
              :class="importDifferenceField.chargeWeightSigning ? 'red-border' : ''"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightSigning"
              no="157"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.weightSigning ? 'red-border' : ''"
              @change="weightSigningChange(true);calcSigningVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageSigning"
              no="158"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.cubageSigning ? 'red-border' : ''"
              @change="cubageSigningChange(true);calcSigningVolumetricAndChargeWeight()"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightSigning"
              no="159"
              :precision="3"
              :min="0"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.chargeWeightSigning ? 'red-border' : ''"
              @change="pm.chargeWeightImperialChange('chargeWeightSigning', 'chargeWeightSigningImperial')"
            />
            <auto-number-input
              v-model="job.densitySigning"
              :precision="3"
              :min="0"
              no="160"
              :disabled="!elementDict.quantitySigning.writable"
              :class="importDifferenceField.densitySigning ? 'red-border' : ''"
            />
            <auto-number-input
              v-if="isFba"
              v-model="job.volumetricWeightSigning"
              no="161"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="calcSigningVolumetricAndChargeWeight(job.volumetricWeightSigning)"
            />
            <el-input v-model="job.dimensionsSigning" no="dimensionsSigning" style="width: 200px;padding-right: 5px" :disabled="!elementDict.quantitySigning.writable" @input="pm.weightCubageChangeHandler('dimensionsSigning')" />
            <el-button :disabled="viewStatus" style="padding-right: 5px" type="primary" @click="commissionDimensionsChange(5)">{{ $t('SeaExport.Size') }}</el-button>
          </el-form-item>
        </div>
        <template v-if="!isFba">
          <el-form-item
            v-if="elementDict.packing && elementDict.packing.viewable"
            slot="packing"
            style="width: fit-content;"
          >
            <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
            <cargo-packing-select
              no="106"
              style="width: 186px"
              :default-value="job.packing"
              :callback-params="{}"
              :disabled="!elementDict.packing.writable"
              placeholder=" "
              :class="importDifferenceField.packing ? 'red-border' : ''"
              @change="p => {p.key = 'packing';setJobSelectValue(p)}"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.pbProportion && elementDict.pbProportion.viewable" slot="pbProportion" label-width="95px" style="width: fit-content;">
            <line-label slot="label" :class="elementDict.pbProportion.isRequire ? 'blue' : ''" :label="elementDict.pbProportion.label" />
            <el-select
              v-if="splitBubbleCollectionFormat"
              :value="job.pbProportion||''"
              :disabled="!elementDict.pbProportion.writable"
              no="107"
              clearable
              :filterable="!pbProportionCheck"
              :allow-create="!pbProportionCheck"
              :class="importDifferenceField.pbProportion ? 'red-border' : ''"
              @focus="onPbProportionFocus"
              @input="val=>{job.pbProportion=val}"
              @change="pm.weightCubageChangeHandler('pbProportion')"
            >
              <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
            <template v-else>
              <el-input-number v-model="job.pbProportion" :disabled="!elementDict.pbProportion.writable" no="107" style="width: 95px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion}" @change="pm.weightCubageChangeHandler('pbProportion')" /><span>%</span>
            </template>
          </el-form-item>
          <el-form-item v-if="elementDict.pbProportion2 && elementDict.pbProportion2.viewable" slot="pbProportion2" label-width="94px" style="margin-left: 10px;width: fit-content;">
            <line-label slot="label" :class="elementDict.pbProportion2.isRequire ? 'blue' : ''" :label="elementDict.pbProportion2.label" />
            <el-select
              v-if="splitBubbleCollectionFormat"
              :value="job.pbProportion2||''"
              no="108"
              clearable
              :disabled="!elementDict.pbProportion2.writable"
              :filterable="!pbProportion2Check"
              :allow-create="!pbProportion2Check"
              :class="importDifferenceField.pbProportion2 ? 'red-border' : ''"
              @focus="onPbProportion2Focus"
              @input="val=>{job.pbProportion2=val}"
              @change="pm.weightCubageChangeHandler('pbProportion2')"
            >
              <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
            <template v-else>
              <el-input-number v-model="job.pbProportion2" :disabled="!elementDict.pbProportion2.writable" no="108" style="width: 85px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion2}" @change="pm.weightCubageChangeHandler('pbProportion2')" /><span>%</span>
            </template>
          </el-form-item>
          <el-form-item v-if="elementDict.slac && elementDict.slac.viewable" slot="slac" label-width="100px" style="margin-left: 10px;width: fit-content;">
            <line-label slot="label" :class="elementDict.slac.isRequire ? 'blue' : ''" :label="elementDict.slac.label" />
            <el-input-number v-model="job.slac" :disabled="!elementDict.slac.writable" no="slac" style="width: 85px;" :class="importDifferenceField.slac ? 'red-border' : ''" :min="0" :precision="0" :controls="false" @change="p=>{pm.slacChangeHandler(p)}" />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.cargoEnglishName && elementDict.cargoEnglishName.viewable" slot="cargoEnglishName" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <cargo-rich-textarea
            v-model="job.cargoEnglishName"
            :show-count="true"
            no="110"
            type="textarea"
            :rows="5"
            :disabled="viewStatus || !elementDict.cargoEnglishName.writable"
            :english-letter-auto-uppercase="isUppercaseByConfig"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,job.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)}, isUppercaseByConfig,{maxChar: 0})"
            @blur="pm.cargoEnglishNameBlurHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mark && elementDict.mark.viewable" slot="mark" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <cargo-rich-textarea
            v-model="job.mark"
            :show-count="true"
            no="111"
            type="textarea"
            :rows="5"
            :disabled="viewStatus || !elementDict.mark.writable"
            :auto-uppercase="isUppercaseByConfig"
            @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,job.mark,val=>{pm.markChangeHandler(val)}, isUppercaseByConfig,{maxChar: 0})"
            @blur="pm.markBlurHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName && elementDict.cargoChineseName.viewable" slot="cargoChineseName" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <cargo-rich-textarea
            v-model="job.cargoChineseName"
            :show-count="true"
            no="112"
            type="textarea"
            :rows="5"
            :disabled="viewStatus || !elementDict.cargoChineseName.writable"
            :auto-uppercase="true"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,job.cargoChineseName,val=>{job.cargoChineseName=val})"
          />
        </el-form-item>
        <!-- 特殊操作码 -->
        <el-form-item v-if="elementDict.specialOperationCode && elementDict.specialOperationCode.viewable" slot="specialOperationCode" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.specialOperationCode.isRequire ? 'blue' : ''" :label="elementDict.specialOperationCode.label" />
          <el-tooltip :content="job.specialOperationCode" placement="left">
            <div slot="content" v-html="job.specialOperationCode || $t('SeaExport.NoData')" />
            <el-input
              no="1211"
              :value="job.specialOperationCode"
              :placeholder="viewStatus ? '' : $t('SeaExport.doubleClickToAddSpecialOperationCode')"
              :rows="6"
              :disabled="!elementDict.specialOperationCode.writable"
              type="textarea"
              style="height: 110px;"
              @dblclick.native="selectSpecialOperationCodeDialog.value=job.specialOperationCode;selectSpecialOperationCodeDialog.visible=!viewStatus"
            />
          </el-tooltip>
        </el-form-item>
        <div v-if="isFba" style="display:flex; text-align: left; margin-left: 20px;">
          <el-row>
            <el-col :span="4.8">
              <el-form-item label-width="80px">
                <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
                <el-radio-group v-model="fbaJob.chargingMethod" no="chargingMethod" @change="chargingMethodChange">
                  <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                  <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item :label="$t('SeaExport.pbProportion')" label-width="80px">
                <span style="display:flex;">
                  <!--                      <el-input-number v-model="fbaJob.bubbleSplittingRatio" style="width: 90px;" no="bubbleSplittingRatio" controls-position="right" :max="100" :min="0" :precision="0" @input="val=>{fbaJob.bubbleSplittingRatio}" @change="p=>{fbaJob.bubbleSplittingRatio=p.value;job.pbProportion=p.value;pm.weightCubageChangeHandler('pbProportion');}" />%-->
                  <el-input v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" @change="bubbleSplittingRatioChange" />%
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item :label="$t('SeaExport.pbProportion2')" label-width="80px">
                <span style="display:flex;">
                  <el-input-number v-model="job.pbProportion2" :disabled="!elementDict.pbProportion2.writable" no="108" style="width: 90px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion2}" @change="pm.weightCubageChangeHandler('pbProportion2')" /><span>%</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item v-if="isFba" :label="$t('FbaChannel.bubbleCountingRatio')" label-width="80px">
                <!--                    <el-input-number v-model="fbaJob.bubbleCountingRatio" style="width: 90px;" no="bubbleCountingRatio" controls-position="right" :max="9999" :min="0" @change="bubbleCountingChange"/>-->
                <el-input v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" style="width: 100%;" @change="bubbleCountingChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div slot="codeSearching">
          <el-button v-if="!isFba" no="CodeSearching" :disabled="viewStatus" type="primary" @click="codeSearch">{{ $t('SeaExport.CodeSearching') }}</el-button>
          <el-button v-if="isFba" no="FbaCodeSearching" :disabled="viewStatus" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
        </div>
        <el-form
          v-show="elementDict.shipper && elementDict.shipper.viewable"
          slot="shipper"
          label-width="50px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item class="custom">
            <template slot="label">
              <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
              <char-count :form="job" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-input v-model="job.shipperCode" :disabled="viewStatus || !elementDict.shipper.writable" no="shipperCode" :class="importDifferenceField.shipperCode ? 'red-border' : ''" style="width:110px;margin-right: 5px" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.shipperCodeChange(data)}" />
            <cargo-company-select
              no="113"
              :disabled="viewStatus ||!elementDict.shipper.writable"
              :method-params="{shipper:true,active:true}"
              :default-value="job.shipperId||''"
              style="display: inline-block;width:135px;"
              :fields="['englishName']"
              tag-name="englishName"
              placeholder=" "
              :class="importDifferenceField.shipperId ? 'red-border' : ''"
              @change="data => {pm.shipperChange(data)}"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              :disabled="viewStatus ||!elementDict.shipper.writable"
              :no="'shipperLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :class="importDifferenceField['shipperLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog(elementDict.shipper.label,mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-show="elementDict.consignee && elementDict.consignee.viewable"
          slot="consignee"
          label-width="50px"
          label-position="left"
          style="margin-right:20px"
        >
          <el-form-item class="custom">
            <template slot="label">
              <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
              <char-count :form="job" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-input v-model="job.consigneeCode" :disabled="viewStatus || !elementDict.consignee.writable" no="consigneeCode" :class="importDifferenceField.consigneeCode ? 'red-border' : ''" style="width:110px;margin-right: 5px" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.consigneeCodeChange(data)}" />
            <cargo-company-select
              no="115"
              :disabled="viewStatus || !elementDict.consignee.writable"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              style="display: inline-block;width:135px;"
              :fields="['englishName']"
              tag-name="englishName"
              placeholder=" "
              :class="importDifferenceField.consigneeId ? 'red-border' : ''"
              @change="data => {pm.consigneeChange(data)}"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              :disabled="viewStatus || !elementDict.consignee.writable"
              :no="'consigneeLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :class="importDifferenceField['consigneeLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog(elementDict.consignee.label,mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-show="elementDict.notify && elementDict.notify.viewable"
          slot="notify"
          label-width="50px"
          label-position="left"
          style="margin-right:20px"
        >
          <el-form-item :label="$t('SeaExport.NotifyParty')" class="custom">
            <template slot="label">
              <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
              <char-count :form="job" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <cargo-input v-model="job.notifyCode" :disabled="viewStatus || !elementDict.notify.writable" no="notifyCode" style="width:110px;margin-right: 5px" :class="importDifferenceField.notifyCode ? 'red-border' : ''" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.notifyCodeChange(data)}" />
            <cargo-company-select
              no="117"
              :disabled="viewStatus || !elementDict.notify.writable"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              style="display: inline-block;width:135px;"
              :fields="['englishName']"
              tag-name="englishName"
              placeholder=" "
              :class="importDifferenceField.notifyId ? 'red-border' : ''"
              @change="data => {pm.notifyChange(data)}"
            />
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" label-width="0">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              :disabled="viewStatus || !elementDict.notify.writable"
              :no="'notifyLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :class="importDifferenceField['notifyLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog(elementDict.notify.label,mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </el-form>
        <div v-if="elementDict.alsoNotify && elementDict.alsoNotify.viewable" slot="alsoNotify">
          <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
          <br>
          <cargo-textarea
            v-model="job.alsoNotify"
            no="119"
            type="textarea"
            :rows="5"
            :disabled="viewStatus || !elementDict.alsoNotify.writable"
            class="also-notify"
            :class="importDifferenceField.alsoNotify ? 'red-border' : ''"
            @dblclick.native="showAdvanceTextDialog(elementDict.alsoNotify.label,job.alsoNotify,val=>{job.alsoNotify=val},notUppercaseShipperConsigneNotify,{maxChar: 0})"
          />
        </div>
        <el-form-item v-if="elementDict.rateType && elementDict.rateType.viewable" slot="rateType">
          <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
          <el-select
            v-model="job.rateType"
            :disabled="viewStatus || !elementDict.rateType.writable"
            no="rateType"
            clearable
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in rateType"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
      </tab-general-UICustom-layout>
    </el-form>
    <!-- 详细信息 -->
    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <!--输入中转信息-->
    <transit-port-dialog :visible.sync="transitPortDialog.visible" :job="transitPortDialog.job" @enter="transitPortDialogCallback" />
    <!--选择主单-->
    <select-mawb-dialog
      :visible.sync="selectMawbDialog.visible"
      :type="selectMawbDialog.type"
      :operate-type="selectMawbDialog.operateType"
      :carrier-id="selectMawbDialog.carrierId"
      @enterEvent="selectedMAWBHandler"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      v-if="selectOperationReqDialog.visible"
      :visible.sync="selectOperationReqDialog.visible"
      lob="AE"
      :value="selectOperationReqDialog.value"
      @callback="val=>{job.operationContent=val;this.pm.syncDocHandlingInfo()}"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    ><cargo-rich-textarea
       v-model="advanceTextDialog.value"
       :disabled="viewStatus"
       :text-chars="advanceTextDialog.formatObj.maxChar"
       :warning-count="advanceTextDialog.formatObj.warningCount"
       style="height: 320px;"
       no="144"
     />
      <span slot="footer">
        <el-button v-show="!viewStatus" no="120" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="121"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="AE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="billAddressDialog.job"
      :params="billAddressDialog.params"
      @callback="codeSearchCallback"
    />
    <!--进仓编号双击弹框-->
    <ware-house-dialog
      :visible.sync="warehouseDialog.visible"
      :job="warehouseDialog.job"
      @warehouseCommitCallback="warehouseCommitCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />

    <!-- 选择尺寸 -->
    <common-dimensions-dialog
      v-if="dimensionsDialog.visible"
      :visible.sync="dimensionsDialog.visible"
      :open-imperial="openImperial"
      @sizeData="sizeDataHandler"
      @close="dimensionsDialog.visible = false"
    />
    <!-- 特殊操作代码弹窗 -->
    <select-special-operation-code-dialog
      v-if="selectSpecialOperationCodeDialog.visible"
      :visible.sync="selectSpecialOperationCodeDialog.visible"
      lob="AE"
      :value="selectSpecialOperationCodeDialog.value"
      @callback="val=>{job.specialOperationCode = val;}"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabGeneralUICustomLayout from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabGeneral from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import StrUtils from '@/utils/StrUtils'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { handleBlur } from '@/utils/commonUtil'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'
import * as TemperatureRequirements from '@/class/cargo/model/parameters/TemperatureRequirements'

export default {
  name: 'TabGeneralUICustom',
  components: { cargoTextarea, tabGeneralUICustomLayout },
  extends: tabGeneral,
  props: {
    previewConfig: { type: Object, default: null },
    context: {
      type: Object,
      required: true
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      handleBlur, AutoComplete,
      TemperatureRequirements,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      editMawblNoMode: 0,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {

    /**
     * CARGO-46018 友邦：空运订舱中主单号只能通过主单管理维护的单号进行选择
     * 0–自由编辑，可手动输入也可选择主单号列表
     * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
     */
    isEditablemawbNoInput() {
      return !(this.propertiesEnabled.mblEnabled && (this.editMawblNoMode === 0 || !(this.editMawblNoMode === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code)))
    },
    showGoodsInfo() {
      return (this.elementDict.goodsInfoContract && this.elementDict.goodsInfoContract.viewable) ||
        (this.elementDict.goodsInfoBooking && this.elementDict.goodsInfoBooking.viewable) ||
        (this.elementDict.goodsInfoActual && this.elementDict.goodsInfoActual.viewable) ||
        (this.elementDict.goodsInfoDocument && this.elementDict.goodsInfoDocument.viewable && this.job.operateType !== 0) ||
        (this.elementDict.quantityStation && this.elementDict.quantityStation.viewable) ||
        (this.elementDict.quantitySigning && this.elementDict.quantitySigning.viewable)
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'job.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.job.exportControlledProduct = ''
        }
      }
    }
  },
  created() {
    this.loadPageConfig()
    this.editMawblNoMode = Number(this.context.config.get('EditMawblNoMode'))
    this.notUppercaseShipperConsigneNotify = Number(this.context.config.get('NotUppercaseShipperConsigneNotify')) !== 1
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.$route.name === 'AeBookingVerify' ? UICustomConstants.AIR_VERIFY_BOOKING_BASIC : UICustomConstants.AIR_BOOKING_BASIC
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row, false)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageType = this.$route.name === 'AeBookingVerify' ? UICustomConstants.AIR_VERIFY_BOOKING_BASIC : UICustomConstants.AIR_BOOKING_BASIC
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId, false)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.job
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (key === 'exChangeAgent') {
            if (!this.job.dischargingPortDoor) {
              continue
            }
          }
          if (key === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
            continue
          }
          if (key === 'shipper' || key === 'shipperCode') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
              throw new TabError(this.$t('SeaExport.ShipperCannotBeBlank'), 'basicTab')
            }
            continue
          }
          if (key === 'consignee' || key === 'consigneeCode') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
              throw new TabError(this.$t('SeaExport.ConsigneeCannotBeEmpty'), 'basicTab')
            }
            continue
          }
          if (key === 'notify' || key === 'notifyCode') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
              throw new TabError(this.$t('SeaExport.NotifierCannotBeBlank'), 'basicTab')
            }
            continue
          }
          if (key === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
            continue
          }
          if (key === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
            continue
          }
          if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
            continue
          }
          if (key.startsWith('shipperCode') || key.startsWith('consigneeCode') || key.startsWith('notifyCode')) {
            continue
          }
          if (key === 'quantityStation' || key === 'quantitySigning') {
            continue
          }
          if (key === 'operateType') {
            if (typeof form[key] !== 'boolean' && form[key] === '') {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
            continue
          }
          if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          } else if (key === 'exChangeAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.exChangeAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          } else if (key === 'cargoCode') {
            if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'basicTab')
            }
          }
        }
      }
      if (this.elementDict.goodsInfoContract && this.elementDict.goodsInfoContract.viewable && this.elementDict.goodsInfoContract.writable && this.elementDict.goodsInfoContract.isRequire) {
        if (!form.quantityContract || !form.weightContract || !form.cubageContract || !form.chargeWeight || !form.densityContract) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoContract.label]), 'basicTab')
        }
      }
      if (this.elementDict.goodsInfoBooking && this.elementDict.goodsInfoBooking.viewable && this.elementDict.goodsInfoBooking.writable && this.elementDict.goodsInfoBooking.isRequire) {
        if (!form.quantityBooking || !form.weightBooking || !form.cubageBooking || !form.chargeWeightBooking || !form.densityBooking) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoBooking.label]), 'basicTab')
        }
      }
      if (this.elementDict.goodsInfoActual && this.elementDict.goodsInfoActual.viewable && this.elementDict.goodsInfoActual.writable && this.elementDict.goodsInfoActual.isRequire) {
        if (!form.quantityActual || !form.weightActual || !form.cubageActual || !form.cWeight || !form.densityActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoActual.label]), 'basicTab')
        }
      }
      if (this.elementDict.goodsInfoDocument && this.elementDict.goodsInfoDocument.viewable && this.elementDict.goodsInfoDocument.writable && this.elementDict.goodsInfoDocument.isRequire) {
        if (form.operateType !== 0 && (!this.mawbDoc.quantity || !this.mawbDoc.weight || !this.mawbDoc.cubage || !this.mawbDoc.cWeight || !form.densityDoc)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoDocument.label]), 'basicTab')
        }
      }
      if (this.elementDict.quantityStation && this.elementDict.quantityStation.viewable && this.elementDict.quantityStation.writable && this.elementDict.quantityStation.isRequire) {
        if (!form.quantityStation || (this.openImperial && (!form.weightStationImperial || !form.cubAgeStationImperial || !form.chargeWeightStationImperial)) ||
            (!this.openImperial && (!form.weightStation || !form.cubageStation || !form.chargeWeightStation)) || !form.densityStation || (this.isFba && !form.volumetricWeightStation)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.quantityStation.label]), 'basicTab')
        }
      }
      if (this.elementDict.quantitySigning && this.elementDict.quantitySigning.viewable && this.elementDict.quantitySigning.writable && this.elementDict.quantitySigning.isRequire) {
        if (!form.quantitySigning || (this.openImperial && (!form.weightSigningImperial || !form.cubAgeSigningImperial || !form.chargeWeightSigningImperial)) ||
            (!this.openImperial && (!form.weightSigning || !form.cubageSigning || !form.chargeWeightSigning)) || !form.densitySigning || (this.isFba && !form.volumetricWeightSigning)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.quantitySigning.label]), 'basicTab')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-ae-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-ae-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app .tab-general-ui-custom {
  .fit-content {
    .form-column {
      width: auto;
    }
  }
}
::v-deep .el-date-editor--datetime.is-disabled{
  input::placeholder{
    color: rgb(153, 153, 153) !important;
  }
}
.goods-info{
  /deep/ .goods-info-item{
    .el-form-item__content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .el-input{
        width: 190px;
        margin-left: 12px;
        text-align: right !important;
      }
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
/deep/ .also-notify {
  width: 310px;
  .el-textarea__inner {
    height: 200px;
  }
}
/deep/ .checkbox-content {
  display: flex;
  .el-checkbox__label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea {
    border: 1px solid red !important;
  }
}
</style>
